<template>
  <v-dialog
    ref="menu1"
    v-model="menu1"
    :return-value.sync="time"
    persistent
    width="290px"
  >

  <!-- :prepend-icon="!showCopyPasteIcon ? undefined : startDateDisplayNormal ? 'mdi-content-copy' : 'mdi-content-paste'"
   @click:prepend="copyPasteItem()"
        :prepend-inner-icon="hideCalenderIcon ? undefined : 'mdi-calendar'" -->

    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="startDateDisplayNormal"
        :label="label ? label : 'Date Time'"
        solo
        readonly
        hide-details
        persistent-hint
        :append-icon="!clearable ? undefined : startDateDisplayNormal ? 'mdi-close' : undefined"
        @click:append="clear"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-card>
      <v-tabs right slider-color="black">
        <v-tab ripple><v-icon>mdi-clock-outline</v-icon></v-tab>
        <v-tab ripple v-if="!hideDate"><v-icon>mdi-calendar</v-icon></v-tab>
        <v-tab-item>
          <v-card flat>
            <v-time-picker v-if="!isReset"
              v-model="startTime"
              class="elevation-0 tile"
            ></v-time-picker>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="!hideDate">
          <v-card flat>
            <v-date-picker
              v-model="startDate"
              class="elevation-0 tile"
            ></v-date-picker>
          </v-card>
        </v-tab-item>
        
      </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DateTimeTextField",
  props: ["initDate", 'hideDate', 'ampmFormat', 'initTime', 'noDefaultTime', 'label', 'hideCalenderIcon', 'clearable', 'showCopyPasteIcon'],
  data: () => ({
    isReset: false,
    active: "date",
    date: null,
    time: null,
    dateFormatted: null,
    menu1: false,
    dateTime: new Date(),
  }),
  mounted() {
    if (this.initDate) {
      // console.log("enteredAt", this.initDate);
      this.date = this.$moment(this.initDate);
      this.time = this.ampmFormat ?  this.$moment(this.initDate).format("hh:mm A") : this.$moment(this.initDate).format("HH:mm");
    } else {
      this.date = this.$moment(this.initDate);
      this.time = this.noDefaultTime ? null : this.ampmFormat ?  this.$moment(this.initDate).format("hh:mm A") : this.$moment(this.initDate).format("HH:mm")
    }
    if(this.initTime){
      this.time = this.initTime
    }
  },
  // updated() {
  //   console.log('test updateded')
  //   if (this.initDate) {
  //     console.log('enteredAt', this.initDate)
  //     this.date = this.initDate;
  //     this.time = this.$moment(this.initDate).format('HH:mm');
  //   }
  // },
  watch: {
    initDate(val) {
      this.date = this.$moment(val);
      this.time = this.ampmFormat ? this.$moment(val).format("hh:mm A") : this.$moment(val).format("HH:mm");
    },
  },
  computed: {
    startDateDisplayNormal: {
      get() {
        this.submitDate();
        if (this.date && !this.hideDate)
        {
          return `${this.date.format("L")} ${this.$moment(this.date).format("LT")}`
        } else {
          return this.time
        }
        // return this.date
        //   ? `${this.date.format('MM/DD/YYYY')} ${
        //       this.time
        //         ? this.$moment(`${this.date.format('YYYY-MM-DD')} ${this.time}`).format('LT')
        //         : ''
        //     }`
        //   : null;
      },
      set() {
        // console.log('set submit', val);
        this.time = null;
        this.date = null;
        return this.submitDate();
      },
    },
    startDate: {
      get() {
        return this.date ? `${this.date.format("YYYY-MM-DD")}` : null;
      },
      set(val) {
        if (!val) return (this.date = null);
        this.date = new this.$moment(val);

        if (this.time) {
          const time = this.time.split(":");
          this.date.set({ hour: time[0], minute: time[1] });
        }
      },
    },
    startTime: {
      get() {
        if(this.hideDate)
          return this.time ? this.convertTo24HourFormat(this.time) : null;
        return this.date ? `${this.date.format("HH:mm")}` : null;
      },
      set(val) {
        this.time = val;
        this.date = new this.$moment(this.date);
        const time = val.split(":");
        this.date.set({ hour: time[0], minute: time[1] });
        // console.log('time set ', this.date.format('L LT'))
        if(this.ampmFormat){
          this.convertToAmPmFormat(val)
        }
      },
    },
  },
  methods: {
    close() {
      this.isReset = true; 
      this.$nextTick(() => { this.isReset = false; })
      if(this.hideDate)
        this.$refs.menu1.save(this.startDateDisplayNormal);
      this.menu1 = false

    },
    copyPasteItem(){
      if(this.time){
        navigator.clipboard.writeText(this.time);
        this.$toast.success("Time Copied", { timeout: 2000 });
      } else {
        navigator.clipboard.readText().then((timeFromClipboard) => {
          this.time = timeFromClipboard
        });
      }
    },
    clear(){
      this.time = null
      this.$emit("input", this.time);
    },
    submitDate() {
      let date = null;
      if (this.date) {
        date = this.date.toISOString();
        if (date) {
          if(this.hideDate){
            this.$emit("input", this.time);
          }
          else
            this.$emit("input", date);
        }
      }
    },
    cancel() {
      this.menu1 = false;
    },
    convertToAmPmFormat(val){
      const [hours, minutes] = val.split(':').map(Number);
      const period = hours >= 12 ? 'PM' : 'AM';
      const hours12 = hours % 12 || 12;
      const time12 = `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
      this.time = time12
    },
    convertTo24HourFormat(val) {
    const [timePart, period] = val.split(' ');
    const [hours, minutes] = timePart.split(':').map(Number);

    let hours24 = hours;
    if (period === 'PM' && hours !== 12) {
        hours24 += 12;
    } else if (period === 'AM' && hours === 12) {
        hours24 = 0;
    }
    const time24 = `${hours24.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    return time24;
}
  },
};
</script>

<style scoped></style>
